import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";

export default function DialogConfirmarExclusao({
  open,
  onClose,
  supplier,
  onExcluido,
  snackbar,
}) {
  const [excluindo, setExcluindo] = useState(false);
  const [vinculado, setVinculado] = useState(false);

  const handleExcluir = async () => {
    if (!supplier) return;
    setExcluindo(true);
    try {
      setVinculado(false);
      snackbar.showMessage("Fornecedor excluído com sucesso.", {
        severity: "success",
      });
      onExcluido();
      onClose();
    } catch (error) {
      const msg = error?.toString() || "Erro ao excluir fornecedor.";
      if (/vinculado|vinculada/i.test(msg)) {
        setVinculado(true);
      } else {
        snackbar.showMessage(msg, { severity: "error" });
      }
    } finally {
      setExcluindo(false);
    }
  };

  if (!supplier) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="dialog-excluir-fornecedor-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="dialog-excluir-fornecedor-title">
        <Typography>Excluir Fornecedor</Typography>
      </DialogTitle>
      <DialogContent>
        {vinculado ? (
          <Typography color="error">
            Este fornecedor está vinculado a outros registros e não pode ser
            excluído. Use a opção Inativar para deixá-lo indisponível.
          </Typography>
        ) : (
          <Typography>
            Deseja realmente excluir o fornecedor &quot;{supplier.Nome}&quot;?
            Esta ação não pode ser desfeita.
          </Typography>
        )}
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <Button onClick={onClose} color="primary" disabled={excluindo}>
          {vinculado ? "Fechar" : "Cancelar"}
        </Button>
        {!vinculado && (
          <Button
            onClick={handleExcluir}
            variant="contained"
            color="primary"
            disabled={excluindo}
          >
            {excluindo ? "Excluindo..." : "Excluir"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
